import m from "./../../../dist/es2015/locales/lt_LT.js";
export const am5locales_lt_LT = m;